import {Controller, useFormContext} from "react-hook-form";
import {ZyusetuFieldKeyFragmentFragment, ZyusetuFieldKeyType,} from "@/graphql/graphql";
import {FormSchema} from "@/components/pages/Zyusetu/ZyusetuEditorSection.tsx";

import {zyusetuValueIntoZodValue} from "@/hooks/useGetFirstContent";
import {DatePicker} from "@mui/x-date-pickers";
import dayjs from "dayjs";
import {FormHelperText} from "@mui/material";

interface ZyusetuDateFieldProps {
  fieldKey: ZyusetuFieldKeyFragmentFragment;
  onFocus: () => void;
  updateField: (
    keyId: string,
    keyName: string,
    value: FormSchema<ZyusetuFieldKeyType.Date>[string],
  ) => Promise<void>;
  isAvailable: boolean;
}

export function ZyusetuDateField({
                                   fieldKey,
                                   onFocus,
                                   updateField,
                                   isAvailable,
                                 }: ZyusetuDateFieldProps) {
  const {control} = useFormContext<FormSchema<ZyusetuFieldKeyType.Date>>();
  
  return (
    <Controller
      name={fieldKey.keyName}
      control={control}
      render={({field, formState: {errors}, fieldState: {isDirty}}) => {
        return (
          <>
            <DatePicker
              inputRef={field.ref}
              format="YYYY年MM月DD日"
              disabled={!isAvailable}
              slotProps={{
                openPickerButton: {
                  tabIndex: -1,
                },
                
                calendarHeader: {format: "YYYY年MM月"},
                textField: {
                  required: true,
                  onFocus: onFocus,
                  fullWidth: true,
                  size: "small",
                  onBlur: async () => {
                    if (errors?.[fieldKey.keyName]?.value?.message) return;
                    if (!isDirty) return;
                    
                    await updateField(fieldKey.id, fieldKey.keyName, field.value);
                  },
                },
              }}
              closeOnSelect={false}
              onClose={async () => {
                if (errors?.[fieldKey.keyName]?.value?.message) return;
                if (!isDirty) return;
                
                await updateField(fieldKey.id, fieldKey.keyName, field.value);
              }}
              {...field}
              onChange={(value) => {
                field.onChange(zyusetuValueIntoZodValue(fieldKey, value));
              }}
              value={dayjs(field.value?.value)}
            />
            {errors?.[fieldKey.keyName]?.value?.message &&
              <FormHelperText style={{color: "red"}}>
                {errors?.[fieldKey.keyName]?.value?.message || ""}
              </FormHelperText>}
          </>
        );
      }}
    />
  );
}
